import { useState } from 'react'
import { ErrorResponse } from '@ocean/api'
import { Mode } from '@ocean/types/dist/appearance'
import { layouts, common, errors, pagination } from '@ocean/ui'
import { PaginationUtils } from '@ocean/utils'
import { ListSectionLayout, ListSectionSegment, ErrorWrapperLayout } from 'layouts'
import { NotificationsHeader, NotificationsList } from 'modules/Notifications/components'
import NotificationsTabs, {
  NotificationsTab,
} from 'modules/Notifications/components/NotificationsTabs'

const { Spinner } = common
const { ErrorResult } = errors
const { Pagination, PaginationContext } = pagination
const { SectionSpaceLayout, SectionLayout, PaginationLayout, PaginationSegment } = layouts

type NotificationsProps = {
  isLoading?: boolean
  error?: ErrorResponse
}

const PAGINATION_OPTIONS = {
  i18Key: 'notifications',
  totalItemsCount: 20,
  currentPageId: 1,
  onPageChange: () => {},
  pageSize: PaginationUtils.pageSizes[15],
  onPageSizeChange: () => {},
}

const Notifications: React.FC<NotificationsProps> = props => {
  const { isLoading, error } = props
  const [activeTab, setActiveTab] = useState(NotificationsTab.Unread)

  if (isLoading) return <Spinner mode={Mode.Light} />
  if (error)
    return (
      <ErrorWrapperLayout>
        <ErrorResult error={error.error} />
      </ErrorWrapperLayout>
    )

  function handleTabChange(value: NotificationsTab) {
    setActiveTab(value)
  }

  // TODO: Handle activeTab type to provide correct items into NotificationsList
  return (
    <PaginationContext.Provider value={PAGINATION_OPTIONS}>
      <NotificationsHeader />
      <SectionLayout>
        <NotificationsTabs activeTab={activeTab} onChange={handleTabChange} />
      </SectionLayout>
      <SectionSpaceLayout>
        <PaginationLayout>
          <PaginationSegment segmentId='content'>
            <ListSectionLayout>
              <ListSectionSegment segmentId='content'>
                <NotificationsList />
              </ListSectionSegment>
            </ListSectionLayout>
          </PaginationSegment>
          <PaginationSegment segmentId='footer'>
            <SectionLayout>
              <Pagination mode={Mode.Light} />
            </SectionLayout>
          </PaginationSegment>
        </PaginationLayout>
      </SectionSpaceLayout>
    </PaginationContext.Provider>
  )
}

export default Notifications
